<template>
	<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="settlementtasklist"
			collapse @item-click="itemClick" v-if="settlementtasklist.length!=0"></v-jstree>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				settlementtasklist: [],
				settlementtasksource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				currentChildren: [],
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				// 获取当前日期的第一天
				var currentDate = new Date();
				var firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

				// 获取当前年份和月份
				var currentYear = firstDayOfMonth.getFullYear();
				var currentMonth = firstDayOfMonth.getMonth() + 1; // JavaScript 中月份是从 0 开始的，因此需要加 1

				// 创建一个空数组用于存储 VJstree 数据结构
				var treeData = [];

				// 循环从 2024 年到当前年份
				for (var year = 2024; year <= currentYear; year++) {
					// 创建年份节点
					var yearNode = {
						"id": "year_" + year,
						"parent": "#",
						"name": year.toString(),
						"children": []
					};

					// 如果是当前年份，则结束月份为当前月份，否则为 12 月
					var endMonth = (year === currentYear) ? currentMonth : 12;

					// 循环月份
					for (var month = 1; month <= endMonth; month++) {
						// 获取当前月份的第一天时间戳
						var firstDayOfMonthTimestamp = new Date(year, month - 1, 1).getTime();

						// 创建月份节点
						var monthNode = {
							"id": firstDayOfMonthTimestamp,
							"parent": "year_" + year,
							"name": month.toString()+'月',
						};

						// 将月份节点添加到年份节点的 children 数组中
						yearNode.children.push(monthNode);
					}

					// 将年份节点添加到 treeData 数组中
					treeData.push(yearNode);
				}

				// 输出 VJstree 数据结构
				//console.log(JSON.stringify(treeData, null, 4));
				this.settlementtasklist = treeData

				// this.loading = true
				// this.settlementtasklist = []
				// this.$api.supplier.listCurrentSettlementDate().then((res) => {
				// 	console.log(res)

				// let year = []
				// let list = JSON.parse(JSON.stringify(res))
				// list.forEach((item) => {
				// 	item.year = this.timestampToYear(item.begin_time * 1000)
				// 	item.parentid = item.year
				// 	let hasyear = year.find((yitem) => {
				// 		return yitem.id == item.year
				// 	})
				// 	if (!hasyear) {
				// 		year.push({
				// 			id: item.year,
				// 			name: item.year,
				// 			parentid:0,
				// 			childrenid:[item.id]
				// 		})
				// 	}else{
				// 		hasyear.childrenid.push(item.id)
				// 	}
				// })
				// list = list.concat(year)
				// let root = []
				// list.forEach((item) => {
				// 	if (item.parentid == 0) {
				// 		root.push(item)
				// 	} else {
				// 		list.forEach((_item) => {
				// 			if (item.parentid == _item.id) {
				// 				if (!_item.children) {
				// 					_item.children = []
				// 				}
				// 				_item.children.push(item)
				// 			}
				// 		})
				// 	}
				// })
				// this.settlementtasklist = root
				// this.settlementtasksource = res
				// this.loading = false

				//})
			},
			itemClick(node, item, e) {
				this.$emit('select', {
					id: item.id,
					name: item.name,
					parentid: item.parentid,
					childrenid: item.childrenid,
					settlementtasksource: this.settlementtasksource

				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			timestampToYear(timestamp) {
				let date = new Date(timestamp)
				let year = date.getFullYear()
				return year
			}
		},
		components: {
			VJstree
		}
	}
</script>